import { Component } from '@verndale/core';
import $ from 'jquery';
import 'slick-carousel/slick/slick';


/* eslint-disable */
class Testimonial extends Component {
  setupDefaults() {
    this.dom = {};

    this.initCarousel();
  }

  addListeners() {}

  initCarousel() {
    var arrowsNav = $('.testimonial-block__navigation-arrows');
    var testimonialCarousel = $('.testimonial-block__carousel');
    if (testimonialCarousel) {
      testimonialCarousel.slick({
        infinite: true,
        autoPlay: false,
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:
          '<button type="button" class="slick-prev" aria-label="Previous Slide"><svg height="42" width="42" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" transform="matrix(-1 0 0 1 41 1)"><circle cx="20" cy="20" r="20" stroke="#fff" stroke-width="2"/><path d="m16.123 25.332 5.08-5.003-5.08-5.114 1.546-1.556 6.627 6.67-6.626 6.671z" fill="#fff"/></g></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next" aria-label="Next Slide"><svg height="42" width="42" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" transform="translate(1 1)"><circle cx="20" cy="20" r="20" stroke="#fff" stroke-width="2"/><path d="m16.123 25.332 5.08-5.003-5.08-5.114 1.546-1.556 6.627 6.67-6.626 6.671z" fill="#fff"/></g></svg></button>',
        appendArrows: arrowsNav,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              arrows: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false
            }
          }
        ]
      });

      viewMoreTestimonial();
    }

    function viewMoreTestimonial() {
      $('.testimonial-block .testimonial-block__carousel-quote-body').each(
        function () {
          var $this = $(this);
          var testimonialQuote = $this.text();
          var testimonialQuoteLength = testimonialQuote.replace(
            / /g,
            ''
          ).length;
          var testimonialStars = $this
            .closest('.testimonial-block__carousel-item')
            .find('.testimonial-block__stars')
            .html();
          var testimonialTitle = $this
            .closest('.testimonial-block__carousel-item')
            .find('.testimonial-block__carousel-item-title')
            .text();
          var testimonialAuthor = $this
            .closest('.testimonial-block__carousel-item')
            .find('.testimonial-block__carousel-item-author')
            .text();
          var viewMore = $this.next();

          if (testimonialQuoteLength <= 125) {
            viewMore.hide();
          } else {
            $this.text(testimonialQuote.substring(0, 125) + '...');
          }

          viewMore.click(function (e) {
            e.preventDefault();

            viewMoreOverlay(
              testimonialStars,
              testimonialTitle,
              testimonialQuote,
              testimonialAuthor
            );
          });
        }
      );
    }

    function viewMoreOverlay(stars, title, quote, author) {
      $('.testimonial-overlay-stars').html(stars);
      $('.testimonial-overlay-title').html(title);
      $('.testimonial-overlay-quote').html(quote);
      $('.testimonial-overlay-author').html(author);
      $('.testimonial-block__overlay-wrapper').addClass('active');

      $('.testimonial-block').hide();
    }

    $('.testimonial-block__overlay .close').on('click', function () {
      $('.testimonial-block__overlay-wrapper').removeClass('active');
      $('.testimonial-block').show();
    });
  }
}

export default Testimonial;
